import libphonenumber, {
  CountryCode,
  getCountries,
  getCountryCallingCode,
  parsePhoneNumberWithError,
} from 'libphonenumber-js';
import type { Maybe } from '@csp/csp-common-model';

export interface CountryDialCode {
  dialCode: string;
  countryCode: string;
}

export class PhoneNumberUtil {
  static getIsoCountryDialCodes(): CountryDialCode[] {
    return getCountries().map(countryCode => ({
      countryCode,
      dialCode: getCountryCallingCode(countryCode),
    }));
  }

  static getIsoCountryDialCodesStartWithEmpty(): CountryDialCode[] {
    return [{ countryCode: '', dialCode: '' }, ...this.getIsoCountryDialCodes()];
  }

  static toInternalFormat(countryCode: string, number: string): string {
    const phoneNumber = parsePhoneNumberWithError(number, countryCode as CountryCode);
    return phoneNumber.format('E.164');
  }

  static toNationalFormat(number: string): string {
    const phoneNumber = parsePhoneNumberWithError(number);
    return phoneNumber.formatNational();
  }

  static toInternationalFormat(countryCode: string, number: string): string {
    const phoneNumber = parsePhoneNumberWithError(number, countryCode as CountryCode);
    return phoneNumber.formatInternational();
  }

  static toDisplayFormat(number: string): string {
    const phoneNumber = parsePhoneNumberWithError(number);
    return phoneNumber.formatInternational();
  }

  static toDisplayFormatSafe(number: string): string {
    try {
      return this.toDisplayFormat(number);
    } catch (err) {
      return number;
    }
  }

  static getCountryCodeSafe(number: string): Maybe<string> {
    return libphonenumber(number)?.country;
  }

  static isValidNumber(number: string): boolean {
    return !!libphonenumber(number)?.isValid();
  }
}
